import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/feature/SectionHeading';
import { activeUsers, hotDiscussions } from '@/mocks/home';

export default function Discussions() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="楼里更精彩"
          icon="ri-chat-smile-2-line"
          title="热帖讨论 · 边整理边唠"
          desc="有人补前情，有人做目录，帖子下面往往比正文还全，看之前先扫一眼评论没坏处。"
          action="进入讨论区"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_340px]">
          <div className="flex flex-col gap-3">
            {hotDiscussions.map((post, index) => (
              <Reveal key={post.id} delay={index * 60}>
                <article className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-300 md:p-5">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-800">
                    {post.author.slice(0, 1)}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-md bg-background-100 px-2 py-0.5 text-xs text-foreground-600">
                        {post.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{post.time}</span>
                    </div>
                    <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950">
                      {post.title}
                    </h3>
                    <div className="mt-2.5 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                      <span className="flex items-center gap-1.5">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-user-line text-[13px]"></i>
                        </span>
                        {post.author}
                      </span>
                      <span className="flex items-center gap-1.5">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-chat-1-line text-[13px]"></i>
                        </span>
                        {post.replies} 条回复
                      </span>
                      <span className="flex items-center gap-1.5 text-primary-600">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-thumb-up-line text-[13px]"></i>
                        </span>
                        {post.likes.toLocaleString()}
                      </span>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="hidden shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 sm:flex"
                  >
                    看楼
                  </button>
                </article>
              </Reveal>
            ))}
          </div>

          <aside className="flex flex-col gap-4">
            <Reveal>
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-trophy-line text-base text-accent-600"></i>
                  </span>
                  本周活跃整理榜
                </h3>
                <ul className="mt-4 space-y-2.5">
                  {activeUsers.map((user) => (
                    <li key={user.id} className="flex items-center gap-3">
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                          user.rank === 1
                            ? 'bg-accent-500 text-foreground-950'
                            : 'bg-background-100 text-foreground-600'
                        }`}
                      >
                        {user.rank}
                      </span>
                      <div className="min-w-0 flex-1">
                        <p className="truncate text-sm font-medium text-foreground-900">{user.name}</p>
                        <p className="text-xs text-foreground-400">{user.badge}</p>
                      </div>
                      <span className="shrink-0 font-heading text-sm font-bold text-foreground-800">
                        {user.score.toLocaleString()}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>

            <Reveal delay={100}>
              <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950">社区小提示</h3>
                <ul className="mt-3 space-y-2.5 text-sm text-foreground-600">
                  {[
                    '发帖带上时间点，方便别人顺线找。',
                    '打包目录尽量写清编号，省得反复问。',
                    '找不到的资源，先去答疑分区搜一下。',
                  ].map((tip) => (
                    <li key={tip} className="flex gap-2 leading-relaxed">
                      <span className="mt-1.5 flex h-3.5 w-3.5 shrink-0 items-center justify-center">
                        <i className="ri-checkbox-circle-line text-sm text-secondary-500"></i>
                      </span>
                      {tip}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </aside>
        </div>
      </div>
    </section>
  );
}